const {CREATURE_LEMURE} = require('./../../creatureIdList')
const {
  SPELL_TRUE_RESURRECTION,
  SPELL_WISH,
} = require('./../../spellIdList')

module.exports = `убивает существо, то через 1к4 часа душа существа восстаёт из Реки Стикс в виде [лемура](CREATURE:${CREATURE_LEMURE}). Если существо не оживляют к этому времени, то только заклинание [Исполнение желаний](SPELL:${SPELL_WISH}), или убийство этого [лемура](CREATURE:${CREATURE_LEMURE}) и сотворение заклинания [Истинное воскрешение](SPELL:${SPELL_TRUE_RESURRECTION}) на изначальное тело существа сможет вернуть его к жизни. Конструкты и дьяволы невосприимчивы к этому эффекту.`
